import { NewdanhmucchiphiphatsinhService } from 'src/services/newdanhmucchiphiphatsinh.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const NEWDANHMUCCHIPHIPHATSINH_NEW_CARE_SUCCESS = 'NEWDANHMUCCHIPHIPHATSINH:NEW_CARE_SUCCESS'
export const NEWDANHMUCCHIPHIPHATSINH_LIST_SUCCESS = 'NEWDANHMUCCHIPHIPHATSINH:FIND_ALL_SUCCESS'
export const NEWDANHMUCCHIPHIPHATSINH_LIST_FAILD = 'NEWDANHMUCCHIPHIPHATSINH:FIND_ALL_FAILD'
export const NEWDANHMUCCHIPHIPHATSINH_COUNT_ASSIGN_SUCCESS = 'NEWDANHMUCCHIPHIPHATSINH:COUNT_ASSIGN_SUCCESS'
export const NEWDANHMUCCHIPHIPHATSINH_COUNT_ASSIGN_FAILD = 'NEWDANHMUCCHIPHIPHATSINH:COUNT_ASSIGN_FAILD'

export const NEWDANHMUCCHIPHIPHATSINH_CREATE_SUCCESS = 'NEWDANHMUCCHIPHIPHATSINH:CREATE_SUCCESS'
export const NEWDANHMUCCHIPHIPHATSINH_CREATE_FAILD = 'NEWDANHMUCCHIPHIPHATSINH:CREATE_FAILD'

export const NEWDANHMUCCHIPHIPHATSINH_IMPORT_SUCCESS = 'NEWDANHMUCCHIPHIPHATSINH:IMPORT_SUCCESS'
export const NEWDANHMUCCHIPHIPHATSINH_SAVE_SUCCESS = 'NEWDANHMUCCHIPHIPHATSINH:SAVE_SUCCESS'
export const NEWDANHMUCCHIPHIPHATSINH_SAVE_FAILD = 'NEWDANHMUCCHIPHIPHATSINH:SAVE_SUCCESS'

export const NEWDANHMUCCHIPHIPHATSINH_DEL_SUCCESS = 'NEWDANHMUCCHIPHIPHATSINH:DEL_SUCCESS'
export const NEWDANHMUCCHIPHIPHATSINH_DEL_FAILD = 'NEWDANHMUCCHIPHIPHATSINH:DEL_FAILD'

export const NEWDANHMUCCHIPHIPHATSINH_ONE_SUCCESS = 'NEWDANHMUCCHIPHIPHATSINH:FIND_ONE_SUCCESS'
export const NEWDANHMUCCHIPHIPHATSINH_ONE_FAILD = 'NEWDANHMUCCHIPHIPHATSINH:FIND_ONE_FAILD'

export const NEWDANHMUCCHIPHIPHATSINH_HISTORY_LIST_SUCCESS = 'NEWDANHMUCCHIPHIPHATSINH:HISTORY_FIND_ALL_SUCCESS'
export const NEWDANHMUCCHIPHIPHATSINH_HISTORY_LIST_FAILD = 'NEWDANHMUCCHIPHIPHATSINH:HISTORY_FIND_ALL_FAILD'

export const NEWDANHMUCCHIPHIPHATSINH_UPDATE_FILTER = 'NEWDANHMUCCHIPHIPHATSINH:NEWDANHMUCCHIPHIPHATSINH_UPDATE_FILTER'

export const NEWDANHMUCCHIPHIPHATSINH_LIST_EXPORT_SUCCESS = 'NEWDANHMUCCHIPHIPHATSINH:FIND_ALL_EXPORT_SUCCESS'
export const NEWDANHMUCCHIPHIPHATSINH_LIST_EXPORT_FAILD = 'NEWDANHMUCCHIPHIPHATSINH:FIND_ALL_EXPORT_FAILD'

export const NEWDANHMUCCHIPHIPHATSINH_UPDATE_HOMEPAGE_FILTER = 'NEWDANHMUCCHIPHIPHATSINH:NEWDANHMUCCHIPHIPHATSINH_UPDATE_HOMEPAGE_FILTER'

export const NEWDANHMUCCHIPHIPHATSINH_HOMEPAGE_LIST_SUCCESS = 'NEWDANHMUCCHIPHIPHATSINH:FIND_HOMEPAGE_LIST_SUCCESS'
export const NEWDANHMUCCHIPHIPHATSINH_HOMEPAGE_LIST_FAILD = 'NEWDANHMUCCHIPHIPHATSINH:FIND_HOMEPAGE_LIST_FAILD'

export const NEWDANHMUCCHIPHIPHATSINH_HOMEPAGE_ONE_SUCCESS = 'NEWDANHMUCCHIPHIPHATSINH:FIND_HOMEPAGE_ONE_SUCCESS'
export const NEWDANHMUCCHIPHIPHATSINH_HOMEPAGE_ONE_FAILD = 'NEWDANHMUCCHIPHIPHATSINH:FIND_HOMEPAGE_ONE_FAILD'

export const NEWDANHMUCCHIPHIPHATSINH_ORDER_SUCCESS = 'NEWDANHMUCCHIPHIPHATSINH:ORDER_SUCCESS'
export const NEWDANHMUCCHIPHIPHATSINH_ORDER_FAILD = 'NEWDANHMUCCHIPHIPHATSINH:ORDER_FAILD'

export const NEWDANHMUCCHIPHIPHATSINH_GET_SIM_ANALYSIS_SUCCESS = 'NEWDANHMUCCHIPHIPHATSINH:GET_SIM_ANALYSIS_SUCCESS'
export const NEWDANHMUCCHIPHIPHATSINH_GET_SIM_ANALYSIS_FAILD = 'NEWDANHMUCCHIPHIPHATSINH:GET_SIM_ANALYSIS_FAILD'

export const NEWDANHMUCCHIPHIPHATSINH_HANDLE_IMPORT_ERRORS = 'NEWDANHMUCCHIPHIPHATSINH:NEWDANHMUCCHIPHIPHATSINH_HANDLE_IMPORT_ERRORS'

export const NewdanhmucchiphiphatsinhAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    updateFilter,
    saveDataUpload,
    findPackage,
    listExport,
    listNoLimit,
    homepageList,
    updateHomepageFilter,
    homepageFindOne,
    sendOrder,
    getSimAnalysis,
    chiphiphatsinhList,
}

function chiphiphatsinhList() {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            NewdanhmucchiphiphatsinhService.chiphiphatsinhList()
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function getSimAnalysis(number) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            // dispatch(AppAction.appLoading(true));
            NewdanhmucchiphiphatsinhService.getSimAnalysis(number).then((response) => {
                dispatch(success(response.data));
                resolve(response);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                // dispatch(AppAction.appLoading(false));
            })
        })
    };
    function success(data) { return { type: NEWDANHMUCCHIPHIPHATSINH_GET_SIM_ANALYSIS_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCCHIPHIPHATSINH_GET_SIM_ANALYSIS_FAILD, error } }
}

function updateHomepageFilter(payload) {
    return { type: NEWDANHMUCCHIPHIPHATSINH_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageList() {
    return (dispatch, getState) => {
        const { newdanhmucchiphiphatsinh } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageNewdanhmucchiphiphatsinhFilter } = newdanhmucchiphiphatsinh;
        const homepageNewdanhmucchiphiphatsinhPage = homepageNewdanhmucchiphiphatsinhFilter.homepageNewdanhmucchiphiphatsinhPage;
        const homepageNewdanhmucchiphiphatsinhLimit = homepageNewdanhmucchiphiphatsinhFilter.homepageNewdanhmucchiphiphatsinhLimit;

        return new Promise((resolve, reject) => {
            NewdanhmucchiphiphatsinhService.homepageList(homepageNewdanhmucchiphiphatsinhFilter).then((rs) => {
                if (!!homepageNewdanhmucchiphiphatsinhFilter && homepageNewdanhmucchiphiphatsinhFilter.homepageNewdanhmucchiphiphatsinhPage === 0) {
                    dispatch(success({
                        homepageNewdanhmucchiphiphatsinhItems: rs.data.values,
                        homepageNewdanhmucchiphiphatsinhTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = newdanhmucchiphiphatsinh.homepageNewdanhmucchiphiphatsinhItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageNewdanhmucchiphiphatsinhLimit * homepageNewdanhmucchiphiphatsinhPage; i < homepageNewdanhmucchiphiphatsinhLimit * homepageNewdanhmucchiphiphatsinhPage + homepageNewdanhmucchiphiphatsinhLimit; i++) {
                        if (typeof rsDataValues[i - homepageNewdanhmucchiphiphatsinhLimit * homepageNewdanhmucchiphiphatsinhPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageNewdanhmucchiphiphatsinhLimit * homepageNewdanhmucchiphiphatsinhPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageNewdanhmucchiphiphatsinhItems: uniqueItems,
                        homepageNewdanhmucchiphiphatsinhTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: NEWDANHMUCCHIPHIPHATSINH_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCCHIPHIPHATSINH_HOMEPAGE_LIST_FAILD, error } }
}

function homepageFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucchiphiphatsinhService.homepageFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCCHIPHIPHATSINH_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCCHIPHIPHATSINH_HOMEPAGE_ONE_FAILD, error } }
}

function updateFilter(payload) {
    return { type: NEWDANHMUCCHIPHIPHATSINH_UPDATE_FILTER, data: payload }
}

function listNoLimit() {
    return (dispatch, getState) => {
      const { account } = getState()
      dispatch(AppAction.appLoading(true));
      NewdanhmucchiphiphatsinhService.listNoLimit().then((rs) => {
        dispatch(success({
            items: rs.data.values,
            total: rs.data.count
        }));
      }).catch((error) => {
        dispatch(failure(error));
      }).finally(() => {
        dispatch(AppAction.appLoading(false));
      })
    };
    function success(data) { return { type: NEWDANHMUCCHIPHIPHATSINH_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCCHIPHIPHATSINH_LIST_FAILD, error } }
  }

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucchiphiphatsinhService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCCHIPHIPHATSINH_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCCHIPHIPHATSINH_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { newdanhmucchiphiphatsinh } = getState()
        dispatch(AppAction.appLoading(true));
        NewdanhmucchiphiphatsinhService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...newdanhmucchiphiphatsinh.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCCHIPHIPHATSINH_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCCHIPHIPHATSINH_LIST_FAILD, error } }
}

function saveDataUpload(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0;
        let errorRows = {};
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            NewdanhmucchiphiphatsinhService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                // if (count === payload.length) {
                //     dispatch(success(rs));
                //     dispatch(AppAction.appLoading(false));
                // }

                if (rs.data.errorRows) {
                    Object.entries(rs.data.errorRows).forEach(([key, value]) => {
                        errorRows[i * 200 + Number(key)] = value;
                    });
                }

                if (i + 200 >= payload.length) {
                    dispatch(handleErrors(errorRows));
                    dispatch(success(rs));
                    dispatch(NewdanhmucchiphiphatsinhAction.list());
                    alert("Tải file thành công: \"" + payload[0].ten_file_upload + "\" (" + count + " bản ghi)");
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function handleErrors(data) { return { type: NEWDANHMUCCHIPHIPHATSINH_HANDLE_IMPORT_ERRORS, data } }
    function success(data) { return { type: NEWDANHMUCCHIPHIPHATSINH_SAVE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCCHIPHIPHATSINH_SAVE_FAILD, error } }
}

function findPackage(ten_goi_cuoc) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            NewdanhmucchiphiphatsinhService.findPackage(ten_goi_cuoc)
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function listExport() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const { newdanhmucchiphiphatsinh } = getState();

            const { filter } = newdanhmucchiphiphatsinh;

            // Perform your asynchronous operation (e.g., API call)
            NewdanhmucchiphiphatsinhService.listExport(filter)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    }
    function success(data) { return { type: NEWDANHMUCCHIPHIPHATSINH_LIST_EXPORT_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCCHIPHIPHATSINH_LIST_EXPORT_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        const { newdanhmucchiphiphatsinh } = getState();
        dispatch(AppAction.appLoading(true));

        const { filter } = newdanhmucchiphiphatsinh;
        const page = filter.page;
        const limit = filter.limit;

        return new Promise((resolve, reject) => {
            NewdanhmucchiphiphatsinhService.findAll(filter.page, filter.limit, filter).then((rs) => {
                if (!!filter && filter.page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                    }));
                } else {
                    const oldItems = newdanhmucchiphiphatsinh.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: NEWDANHMUCCHIPHIPHATSINH_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCCHIPHIPHATSINH_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: NEWDANHMUCCHIPHIPHATSINH_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            NewdanhmucchiphiphatsinhService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(NewdanhmucchiphiphatsinhAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: NEWDANHMUCCHIPHIPHATSINH_SAVE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCCHIPHIPHATSINH_SAVE_FAILD, error } }
}

function create(payload, creatingFromAway = false) {
    return dispatch => {
        if (!creatingFromAway) dispatch(AppAction.appLoading(true));
        NewdanhmucchiphiphatsinhService.create(payload).then((rs) => {
            dispatch(success(rs));
            if (!creatingFromAway) dispatch(NewdanhmucchiphiphatsinhAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể tạo, có thể do trùng mã!");
        }).finally(() => {
            if (!creatingFromAway) dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCCHIPHIPHATSINH_CREATE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCCHIPHIPHATSINH_CREATE_FAILD, error } }
}

function update(id, payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucchiphiphatsinhService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(NewdanhmucchiphiphatsinhAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể cập nhật, có thể do trùng mã!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCCHIPHIPHATSINH_CREATE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCCHIPHIPHATSINH_CREATE_FAILD, error } }
}

function del(id) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucchiphiphatsinhService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(NewdanhmucchiphiphatsinhAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCCHIPHIPHATSINH_DEL_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCCHIPHIPHATSINH_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucchiphiphatsinhService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCCHIPHIPHATSINH_ONE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCCHIPHIPHATSINH_ONE_FAILD, error } }
}

function assign(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucchiphiphatsinhService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(NewdanhmucchiphiphatsinhAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}

function history(payload) {
    return (dispatch, getState) => {
        const { newdanhmucchiphiphatsinh } = getState()
        dispatch(AppAction.appLoading(true));
        NewdanhmucchiphiphatsinhService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...newdanhmucchiphiphatsinh.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCCHIPHIPHATSINH_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCCHIPHIPHATSINH_HISTORY_LIST_FAILD, error } }
}

function sendOrder(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucchiphiphatsinhService.sendOrder(payload).then((rs) => {
            dispatch(success(rs));
            alert("Đặt hàng thành công!");
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể đặt sim này, có thể do hiện tại sim này đã bán. Bạn vui lòng chọn sim khác. Xin cảm ơn!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCCHIPHIPHATSINH_ORDER_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCCHIPHIPHATSINH_ORDER_FAILD, error } }
}